
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astrologer-tarot-profile",
      function () {
        return require("private-next-pages/astrologer-tarot-profile/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astrologer-tarot-profile"])
      });
    }
  